(function () {
  function updateFreeShippingBox() {
    const box = document.querySelector(".revel-free-shipping-box");
    if (!box) return;

    const title = box.querySelector(".revel-free-shipping-title");
    const text = box.querySelector(".revel-free-shipping-text");
    const bar = box.querySelector(".revel-free-shipping-progress-bar");

    if (title) title.textContent = "Kostenloser Versand inklusive.";
    if (text) text.textContent = "Dein Versand nach Österreich und Deutschland ist kostenlos. Lieferzeit 6 bis 10 Werktage.";
    if (bar) bar.style.width = "100%";
  }

  document.addEventListener("DOMContentLoaded", updateFreeShippingBox);

  const observerTarget =
    document.querySelector("cart-items") || document.querySelector(".cart__items");

  if (observerTarget) {
    const observer = new MutationObserver(updateFreeShippingBox);
    observer.observe(observerTarget, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();